"use client";

import { c as _c } from "react/compiler-runtime";
import { useDomainEventInvalidation } from "@/hooks/useDomainEventInvalidation";
import { useProjectDocumentStore } from "@/stores/useProjectDocumentStore";
type UseProjectDocumentIndexingEventsOptions = {
  enabled?: boolean;
  /** When set, also listens on the conversation scope key (project-scoped events still match). */
  conversationId?: string | null;
  /** When the event payload lacks documentId or indexingStatus. */
  onMalformedEvent?: () => void;
};

/**
 * Applies document indexing lifecycle patches from resource-events into the project document store.
 * In-place store updates only; does not refetch lineage or workflow snapshots.
 */
export function useProjectDocumentIndexingEvents(projectId, t0) {
  const $ = _c(16);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const options = t1;
  const {
    enabled: t2,
    conversationId: t3,
    onMalformedEvent
  } = options;
  const enabled = t2 === undefined ? true : t2;
  const conversationId = t3 === undefined ? null : t3;
  const patchDocumentIndexing = useProjectDocumentStore(_temp);
  const invalidateProject = useProjectDocumentStore(_temp2);
  const t4 = projectId ?? undefined;
  let t5;
  if ($[2] !== conversationId || $[3] !== t4) {
    t5 = {
      projectId: t4,
      conversationId
    };
    $[2] = conversationId;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = ["document.indexing_status_changed"];
    t7 = ["document"];
    $[5] = t6;
    $[6] = t7;
  } else {
    t6 = $[5];
    t7 = $[6];
  }
  let t8;
  if ($[7] !== invalidateProject || $[8] !== onMalformedEvent || $[9] !== patchDocumentIndexing || $[10] !== projectId) {
    t8 = event => {
      if (!projectId) {
        return;
      }
      const documentId = event.payload?.documentId;
      const indexingStatus = event.payload?.indexingStatus;
      if (documentId && indexingStatus) {
        const patched = patchDocumentIndexing(projectId, documentId, indexingStatus, event.payload?.indexingError);
        if (!patched) {
          invalidateProject(projectId);
        }
      } else {
        onMalformedEvent?.();
      }
    };
    $[7] = invalidateProject;
    $[8] = onMalformedEvent;
    $[9] = patchDocumentIndexing;
    $[10] = projectId;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const t9 = Boolean(projectId) && enabled;
  let t10;
  if ($[12] !== t5 || $[13] !== t8 || $[14] !== t9) {
    t10 = {
      scope: t5,
      eventTypes: t6,
      entityTypesAffected: t7,
      onInvalidate: t8,
      enabled: t9
    };
    $[12] = t5;
    $[13] = t8;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  useDomainEventInvalidation(t10);
}
function _temp2(s_0) {
  return s_0.invalidateProject;
}
function _temp(s) {
  return s.patchDocumentIndexing;
}